import React, { memo } from "react";

import type { SlateRenderElementProps } from "../slateTypes";

const CodeLine: React.FC<SlateRenderElementProps> = memo(props => {
  return (
    <div {...props.attributes} style={{ position: "relative" }}>
      {props.children}
    </div>
  );
});

export { CodeLine };
